
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58 51.88H36.14L5.6 16.85S17.28 3.87 19.44 3s5.19-.44 5.63 2.24-.44 5.37 3.46 10.3 12.11 4.92 12.11 4.92L48 41.14s10 .18 10 10.74z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M58 51.01v6.44H33.84L2 20.64l4.41-4.57M9 38.41H0M14 44.66H0M20 50.91H0M11.25 23.45a8.5 8.5 0 00.68-13.59"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M48 41.14h-7l-9-22.73M36.49 30.15a20.74 20.74 0 00-14.77 5.21"}})])
          )
        }
      }
    